/**
 * Statuses API
 *
 * API functions for managing a project's custom work item statuses.
 */

import { api } from "./client";
import type {
  ProjectId,
  WorkItemStatus,
  WorkItemStatusId,
  CreateStatusRequest,
  UpdateStatusRequest,
  ReorderStatusesRequest,
} from "./types";

export async function listStatuses(
  projectId: ProjectId,
  includeArchived = false,
): Promise<WorkItemStatus[]> {
  const query = includeArchived ? "?include_archived=true" : "";
  return api.get<WorkItemStatus[]>(`/projects/${projectId}/statuses${query}`);
}

export async function createStatus(
  projectId: ProjectId,
  request: CreateStatusRequest,
): Promise<WorkItemStatus> {
  return api.post<WorkItemStatus>(`/projects/${projectId}/statuses`, request);
}

export async function updateStatus(
  id: WorkItemStatusId,
  request: UpdateStatusRequest,
): Promise<WorkItemStatus> {
  return api.patch<WorkItemStatus>(`/statuses/${id}`, request);
}

export async function reorderStatuses(
  projectId: ProjectId,
  request: ReorderStatusesRequest,
): Promise<WorkItemStatus[]> {
  return api.post<WorkItemStatus[]>(
    `/projects/${projectId}/statuses/reorder`,
    request,
  );
}

export async function archiveStatus(
  id: WorkItemStatusId,
): Promise<WorkItemStatus> {
  return api.post<WorkItemStatus>(`/statuses/${id}/archive`, {});
}

export async function unarchiveStatus(
  id: WorkItemStatusId,
): Promise<WorkItemStatus> {
  return api.post<WorkItemStatus>(`/statuses/${id}/unarchive`, {});
}

export async function deleteStatus(id: WorkItemStatusId): Promise<void> {
  return api.delete(`/statuses/${id}`);
}
